import auth from './auth.yaml'

export default {
  auth,
}
